"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mui_1 = require("tss-react/mui");
const Select_1 = __importDefault(require("@mui/material/Select"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const EditRounded_1 = __importDefault(require("@mui/icons-material/EditRounded"));
const EditableLabel_1 = __importDefault(require("components/EditableLabel"));
const styles_1 = require("./styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const HeaderTitleLeft = ({ title, isEditableTitle, monthsToView, onTitleChange, onViewChange, dateRangeMenu, }) => {
    var _a, _b;
    const { classes, theme } = useStyles();
    return (<div className={classes.headerTitle}>
      {isEditableTitle ?
            <EditableLabel_1.default handleSubmit={onTitleChange} value={title} 
            // @ts-expect-error: Property 'featureHeader' does not exist on type 'Components<BaseTheme>'.
            variant={(_a = theme.components) === null || _a === void 0 ? void 0 : _a.featureHeader.titleVariant} icon={<EditRounded_1.default className={classes.editableIcon} fontSize="small"/>} 
            // @ts-expect-error:  Property 'classes' does not exist on type 'IntrinsicAttributes & EditableLabelProps'.
            classes={{ container: classes.editableLabelContainer }}/>
            :
                <Typography_1.default 
                // @ts-expect-error: Property 'featureHeader' does not exist on type 'Components<BaseTheme>'.
                variant={(_b = theme.components) === null || _b === void 0 ? void 0 : _b.featureHeader.titleVariant} noWrap id="transaction-page-title">
          {title}
        </Typography_1.default>}

      {dateRangeMenu &&
            <>
          <Typography_1.default variant="body1" noWrap style={{ marginLeft: isEditableTitle ? 1 : 15 }}>
            {'(Showing '}
          </Typography_1.default>
          <Select_1.default id="reg-date-limit-select" value={monthsToView} onChange={onViewChange} style={{ marginLeft: 7 }} disableUnderline>
            <MenuItem_1.default value={2}> 2 Months </MenuItem_1.default>
            <MenuItem_1.default value={6}> 6 Months </MenuItem_1.default>
            <MenuItem_1.default value={12}> 12 Months </MenuItem_1.default>
            <MenuItem_1.default value={24}> 2 Years </MenuItem_1.default>
            <MenuItem_1.default value={9999}> All </MenuItem_1.default>
          </Select_1.default>
          <Typography_1.default variant="body1" noWrap className={classes.dateRangeText}>
            {'of Transactions'}
          </Typography_1.default>
          <Typography_1.default variant="body1" noWrap>
            {' )'}
          </Typography_1.default>
        </>}
    </div>);
};
exports.default = HeaderTitleLeft;
